// extracted by mini-css-extract-plugin
export default {"header":"ModalOptions_header__4HoZi","title":"ModalOptions_title__13ss-","cross":"ModalOptions_cross__M41ml","content":"ModalOptions_content__g9PTy"};